import { ROUTES } from '#/config/routes';
import {
  createAsyncMultiFilterMeta,
  createFixedMultiFilterMeta,
  createTextFilterMeta,
  createTreeMultiFilterMeta,
} from '#/modules/commonComponents/table/columnFilterMeta';
import { createDocumentNavLinksColumn } from '#/modules/commonComponents/table/tableColumnHelpers';
import { renderEntityStatusBadge } from '#/modules/commonComponents/table/entityStatusIconHelpers';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';
import {
  formatMtrKindLabel,
  formatOriginalSerialList,
  MTR_KIND_FILTER_OPTIONS,
  MTR_STATUS_FILTER_OPTIONS,
  searchManufacturerFilterOptions,
} from '#/modules/imsMgmt/settings/mtr/helper/mtrFilterOptions';

export function buildMtrColumns({
  filters = {},
  onFilterChange,
  canShowEdit = () => true,
}) {
  return [
    createDocumentNavLinksColumn({
      getDetailPath: (row) => ROUTES.mtrDetail(row.id),
      getEditPath: (row) => ROUTES.mtrEdit(row.id),
      canShowEdit,
    }),
    {
      header: '料號',
      accessorKey: 'mtrNo',
      size: 140,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'mtrNo',
        label: '料號',
        filterValue: filters.mtrNo,
        onChange: (value) => onFilterChange('mtrNo', value),
        placeholder: '搜尋料號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.mtrNo || '—'} />
      ),
    },
    {
      header: '名稱',
      accessorKey: 'name',
      size: 180,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'name',
          label: '名稱',
          filterValue: filters.name,
          onChange: (value) => onFilterChange('name', value),
          placeholder: '搜尋名稱',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.name || '—'} />
      ),
    },
    {
      id: 'status',
      header: '狀態',
      accessorKey: 'status',
      size: 96,
      enableColumnFilter: true,
      cell: ({ getValue }) => renderEntityStatusBadge(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'status',
        label: '狀態',
        options: MTR_STATUS_FILTER_OPTIONS,
        filterValue: filters.status,
        onChange: (value) => onFilterChange('status', value),
      }),
    },
    {
      id: 'mtrKind',
      header: '物料類型',
      accessorKey: 'mtrKind',
      size: 112,
      enableColumnFilter: true,
      cell: ({ getValue }) => formatMtrKindLabel(getValue()),
      meta: createFixedMultiFilterMeta({
        key: 'mtrKind',
        label: '物料類型',
        options: MTR_KIND_FILTER_OPTIONS,
        filterValue: filters.mtrKind,
        onChange: (value) => onFilterChange('mtrKind', value),
      }),
    },
    {
      id: 'mtrStructMain',
      header: '主分類',
      accessorFn: (row) => row.mtrStructMain?.name ?? '-',
      size: 120,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructMainId',
        label: '主分類',
        treeRole: 'main',
        filterValue: filters.mtrStructMainId,
        onChange: (value) => onFilterChange('mtrStructMainId', value),
      }),
    },
    {
      id: 'mtrStructSub',
      header: '次分類',
      accessorFn: (row) => row.mtrStructSub?.name ?? '-',
      size: 120,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTreeMultiFilterMeta({
        key: 'mtrStructSubId',
        label: '次分類',
        treeRole: 'sub',
        filterValue: filters.mtrStructSubId,
        onChange: (value) => onFilterChange('mtrStructSubId', value),
      }),
    },
    {
      id: 'manufacturer',
      header: '製造商',
      accessorFn: (row) => row.manufacturer?.name ?? '-',
      size: 140,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createAsyncMultiFilterMeta({
          key: 'manufacturerId',
          label: '製造商',
          searchOptions: searchManufacturerFilterOptions,
          filterValue: filters.manufacturerId,
          onChange: (value) => onFilterChange('manufacturerId', value),
        }),
      },
    },{
      id: 'originalSerialList',
      header: '原廠料號',
      accessorFn: (row) => formatOriginalSerialList(row.originalSerialList),
      size: 160,
      enableSorting: true,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'originalSerialList',
          label: '原廠料號',
          filterValue: filters.originalSerialList,
          onChange: (value) => onFilterChange('originalSerialList', value),
          placeholder: '搜尋原廠料號',
        }),
      },
    },
    {
      header: '備註',
      accessorKey: 'remark',
      size: 160,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (value) => onFilterChange('remark', value),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={row.original?.remark || '—'} />
      ),
    },
  ];
}
